export default __webpack_public_path__ + "305b66b06b09ce52221565c1cc3baf3b.svg";